(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["unitz-appliance-guide"]) return;
  try {
    
(() => {
 const host=document.querySelector('.ua-guide');if(!host)return;
 const form=host.querySelector('[data-ua-form]');if(!form)return;
 const t=JSON.parse(host.querySelector('[data-ua-labels]').textContent);
 const result=host.querySelector('[data-ua-result]');
 const create=(tag,text)=>{const element=document.createElement(tag);element.textContent=text;return element};
 form.addEventListener('submit',event=>{
  event.preventDefault();const values=new FormData(form);const project=values.get('project'),room=values.get('room'),priority=values.get('priority');
  result.replaceChildren(create('h3',t.result));const list=document.createElement('ul');
  for(const key of [project,room,priority])if(t[key])list.append(create('li',t[key]));result.append(list);
  const groups={daily:['geschirrspueler','kuehlen-gefrieren'],cooking:['kochfelder','backoefen','dunstabzug'],storage:['kuehlen-gefrieren'],laundry:['waschen-trocknen']};
  const wanted=new Set(groups[priority]||[]);if(room==='open')wanted.add('dunstabzug');
  host.querySelectorAll('.ua-category').forEach(card=>{if([...wanted].some(key=>card.getAttribute('href').endsWith('-'+key))){const link=document.createElement('a');link.href=card.href;link.textContent=card.querySelector('h3').textContent;result.append(link)}});
  const all=create('a',t.all+' →');all.href='#kategorien';result.append(all);result.hidden=false;result.focus();
 });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["unitz-flat-assembly"] && !Shopify.designMode) return;
  try {
    
(()=>{const run=root=>{const list=root.querySelector('[data-uzf-check]');if(!list)return;const out=root.querySelector('[data-uzf-progress]');const boxes=[...list.querySelectorAll('input')];
const upd=()=>{const n=boxes.filter(b=>b.checked).length;out.textContent=n===boxes.length?'Alles bereit – viel Spaß beim Aufbau!':(n?n+' von '+boxes.length+' bereit':'');};
boxes.forEach(b=>b.addEventListener('change',upd));};
document.querySelectorAll('.uzf').forEach(run);document.addEventListener('click',e=>{const b=e.target.closest('[data-uzf-print]');if(!b)return;document.documentElement.classList.add('uzf-printing');window.print();setTimeout(()=>document.documentElement.classList.remove('uzf-printing'),500);});document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('.uzf').forEach(run));})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["unitz-guide-article"]) return;
  try {
    
if (!customElements.get('unitz-guide-article')) {
  customElements.define('unitz-guide-article', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const headings = [...this.querySelectorAll('[data-guide-body] h2')];
      const toc = this.querySelector('[data-toc]');
      headings.forEach((heading, index) => {
        if (!heading.id) heading.id = 'guide-section-' + (index + 1);
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = '#' + heading.id;
        link.textContent = heading.textContent;
        item.append(link);
        toc.querySelector('ol').append(item);
      });
      toc.hidden = headings.length === 0;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["unitz-guide-hub"]) return;
  try {
    
if (!customElements.get('unitz-guide-hub')) {
  customElements.define('unitz-guide-hub', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const controls = this.querySelector('[data-controls]');
      if (!controls) return;
      const cards = [...this.querySelectorAll('[data-guide]')];
      const input = this.querySelector('[data-search-input]');
      const buttons = [...this.querySelectorAll('[data-filter]')];
      let category = 'all';
      const normalize = value => value.toLocaleLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ß/g, 'ss');
      const update = () => {
        const words = normalize(input.value.trim()).split(/\s+/).filter(Boolean);
        let count = 0;
        cards.forEach(card => {
          const match = (category === 'all' || card.dataset.topic === category) && words.every(word => normalize(card.dataset.search).includes(word));
          card.hidden = !match;
          if (match) count++;
        });
        this.querySelector('[data-count]').textContent = count;
        this.querySelector('[data-empty]').hidden = count !== 0;
        buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.filter === category)));
      };
      input.addEventListener('input', update);
      buttons.forEach(button => button.addEventListener('click', () => { category = button.dataset.filter; update(); }));
      this.querySelector('[data-reset]').addEventListener('click', () => { input.value = ''; category = 'all'; update(); input.focus(); });
      controls.hidden = false;
      update();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["unitz-kitchen-finder"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('unitz-kitchen-finder')) {
  customElements.define('unitz-kitchen-finder', class extends HTMLElement {
    connectedCallback() {
      if(this.initialized)return;
      this.initialized=true;
      this.t=JSON.parse(this.querySelector('[data-text]').textContent);
      this.products=JSON.parse(this.querySelector('[data-products]').textContent).filter(p=>p.url&&Array.isArray(p.variants));
      this.stage=this.querySelector('.uz-stage');
      this.answers={};this.index=-1;
      this.steps=[['shape',['straight','lshape','ushape','island','any']],['space',['small','s210','s270','s280','s330','any']],['style',['modern','country','any']],['assembly',['prebuilt','flat','any']],['equipment',['yes','no','any']],['budget',['b1000','b2000','b3000','b5000','unlimited']]];
      this.render(false);
    }
    el(tag,text,className){const e=document.createElement(tag);if(text!==undefined)e.textContent=text;if(className)e.className=className;return e;}
    button(key,action,secondary=false){const b=this.el('button',this.t[key],secondary?'uz-secondary':'');b.type='button';b.addEventListener('click',action);return b;}
    render(focus=true){
      this.stage.replaceChildren();
      if(this.index<0){this.stage.append(this.button('start',()=>{this.index=0;this.render();}));return;}
      if(this.index===this.steps.length){this.showResults();if(focus)this.stage.querySelector('h3').focus();return;}
      const [key,options]=this.steps[this.index];
      const status=this.el('p',`${this.t.step} ${this.index+1} ${this.t.of} ${this.steps.length}`);status.setAttribute('aria-live','polite');this.stage.append(status);
      const progress=this.el('progress');progress.max=this.steps.length;progress.value=this.index+1;progress.setAttribute('aria-label',status.textContent);this.stage.append(progress);
      const field=this.el('fieldset',undefined,'uz-options');const legend=this.el('legend',this.t[key]);legend.tabIndex=-1;field.append(legend);
      const next=this.button(this.index===5?'show':'next',()=>{if(!this.answers[key])return;this.index++;this.render();});next.disabled=!this.answers[key];
      for(const option of options){const label=this.el('label');const input=this.el('input');input.type='radio';input.name=this.id+'-'+key;input.value=option;input.checked=this.answers[key]===option;input.addEventListener('change',()=>{this.answers[key]=option;next.disabled=false;});label.append(input,this.el('span',this.t[option]));field.append(label);}
      this.stage.append(field);const actions=this.el('div',undefined,'uz-actions');actions.append(this.button('back',()=>{this.index--;this.render();},true),next);this.stage.append(actions);if(focus)legend.focus();
    }
    matches(){
      const a=this.answers;if(!['straight','any'].includes(a.shape)||a.space==='small')return [];
      const maxWidth={s210:210,s270:270,s280:280,s330:330,any:Infinity}[a.space];
      const maxPrice={b1000:100000,b2000:200000,b3000:300000,b5000:500000,unlimited:Infinity}[a.budget];
      const matches=[];
      for(const p of this.products){
        if(a.style!=='any'&&a.style!==p.style)continue;
        if(a.assembly!=='any'&&a.assembly!==p.assembly)continue;
        const variants=p.variants.filter(v=>{
          const title=v.title.toLowerCase();const m=title.match(/(\d{3})\s*cm/);const width=m?Number(m[1]):Number(p.width);
          const equipment=/ohne elektro|leerzeile/.test(title)?'no':/mit elektro/.test(title)?'yes':'unknown';
          return v.available&&width>0&&width<=maxWidth&&v.price>0&&v.price<=maxPrice&&(a.equipment==='any'||a.equipment===equipment);
        }).sort((x,y)=>x.price-y.price);
        if(variants.length)matches.push({p,v:variants[0]});
      }
      return matches.sort((x,y)=>x.v.price-y.v.price);
    }
    showResults(){
      const matches=this.matches();const heading=this.el('h3',this.t[matches.length?'results':'empty']);heading.tabIndex=-1;this.stage.append(heading);
      const summary=this.el('div',undefined,'uz-summary');for(const [key] of this.steps)summary.append(this.el('span',this.t[this.answers[key]]));this.stage.append(summary);
      if(!matches.length)this.stage.append(this.el('p',this.t.empty_text));
      const grid=this.el('div',undefined,'uz-grid');
      for(const {p,v} of matches){const card=this.el('article',undefined,'uz-card');if(p.image){const img=this.el('img');img.src=p.image;img.alt=p.title;img.loading='lazy';img.width=800;img.height=600;card.append(img);}card.append(this.el('h3',p.title),this.el('p',this.t.variant+': '+v.title));const width=v.title.match(/(\d{3})\s*cm/);card.append(this.el('p',this.t.width+': '+(width?width[1]:p.width)+' cm'));card.append(this.el('strong',new Intl.NumberFormat(document.documentElement.lang||'de-DE',{style:'currency',currency:this.dataset.currency||'EUR'}).format(v.price/100)));const link=this.el('a',this.t.view,'uz-result-link');const url=new URL(p.url,location.origin);url.searchParams.set('variant',v.id);const preview=new URLSearchParams(location.search).get('preview_theme_id');if(preview)url.searchParams.set('preview_theme_id',preview);link.href=url.toString();card.append(link);grid.append(card);}
      this.stage.append(grid,this.button('restart',()=>{this.answers={};this.index=0;this.render();},true));
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["unitz-product-finder"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get("unitz-product-finder")) {
  customElements.define("unitz-product-finder", class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.t = JSON.parse(this.querySelector("[data-finder-text]").textContent);
      this.stage = this.querySelector("[data-stage]");
      this.status = this.querySelector("[data-status]");
      this.groups = [...this.querySelectorAll("[data-finder-group]")].filter(group => group.content.querySelector('[data-url*="/collections/"]'));
      this.cache = new Map();
      this.budget = "";
      this.sort = "relevance";
      this.onlyAvailable = true;
      this.sequence = 0;
      this.showAreas(false);
      const handle = new URL(location.href).searchParams.get("finder");
      if (handle) {
        for (const group of this.groups) {
          const category = [...group.content.querySelectorAll("[data-url]")].find(b => b.dataset.url.split("/").pop() === handle);
          if (category) {
            this.group = group;
            this.category = {...category.dataset};
            this.showBudget(false);
            break;
          }
        }
      }
    }
    esc(value) {
      return String(value).replace(/[&<>"']/g, c => ({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}[c]));
    }
    heading(step, text, focus = true) {
      this.sequence++;
      if (this.controller) this.controller.abort();
      this.status.textContent = "";
      this.querySelectorAll("[data-step]").forEach((li,i) => {
        if(i === step) li.setAttribute("aria-current","step");
        else li.removeAttribute("aria-current");
      });
      this.stage.innerHTML = '<h3 tabindex="-1">' + this.esc(text) + '</h3>';
      if (focus) this.stage.querySelector("h3").focus({preventScroll:true});
    }
    button(text, action, secondary = false) {
      const button = document.createElement("button");
      button.type = "button";
      button.className = "upf-button" + (secondary ? " upf-button--secondary" : "");
      button.textContent = text;
      button.addEventListener("click", action);
      return button;
    }
    actions() {
      const actions = document.createElement("div");
      actions.className = "upf-actions";
      this.stage.append(actions);
      return actions;
    }
    showAreas(focus = true) {
      this.heading(0,this.t.choose_area,focus);
      const choices = document.createElement("div");
      choices.className = "upf-choices";
      this.groups.forEach(group => {
        const button = this.button(group.dataset.title, () => {
          this.group = group;
          this.showTypes();
        });
        button.className = "upf-choice";
        choices.append(button);
      });
      this.stage.append(choices);
    }
    showTypes() {
      this.heading(1,this.t.choose_type);
      const label = document.createElement("p");
      label.className = "upf-summary";
      label.textContent = this.group.dataset.title;
      this.stage.append(label);
      const choices = document.createElement("div");
      choices.className = "upf-choices";
      choices.append(this.group.content.cloneNode(true));
      choices.querySelectorAll("[data-url]").forEach(button => button.addEventListener("click", () => {
        this.category = {...button.dataset};
        this.showBudget();
      }));
      this.stage.append(choices);
      this.actions().append(this.button(this.t.back,()=>this.showAreas(),true));
    }
    hint() {
      const text = (this.group.dataset.title + " " + this.category.title).toLowerCase();
      if (/leucht|licht/.test(text)) return this.t.hint_lighting;
      if (/badezimmer|badmöbel|brausen|sanitär/.test(text)) return this.t.hint_bath;
      if (/kinder|wickel|lernt/.test(text)) return this.t.hint_children;
      if (/küche|backöf|armatur/.test(text)) return this.t.hint_kitchen;
      if (/garten|werkzeug/.test(text)) return this.t.hint_garden;
      if (/zimmer|flur|büro|möbel|sessel/.test(text)) return this.t.hint_furniture;
      return this.t.hint_default;
    }
    showBudget(focus = true) {
      this.heading(2,this.t.choose_budget,focus);
      const currency = this.dataset.currency;
      const id = this.closest("section").id + "-budget";
      this.stage.insertAdjacentHTML("beforeend",
        '<p class="upf-summary">'+this.esc(this.group.dataset.title+" · "+this.category.title)+'</p>'+
        '<form class="upf-form"><label class="upf-field" for="'+id+'">'+this.esc(this.t.max_price+" ("+currency+")")+
        '<input id="'+id+'" name="budget" type="number" min="0" step="0.01" inputmode="decimal" placeholder="'+this.esc(this.t.unlimited)+'" value="'+this.esc(this.budget)+'"></label>'+
        '<label class="upf-field">'+this.esc(this.t.sort)+'<select name="sort">'+
        [["relevance",this.t.relevance],["low",this.t.low],["high",this.t.high]].map(([v,l])=>'<option value="'+v+'"'+(this.sort===v?' selected':'')+'>'+this.esc(l)+'</option>').join("")+
        '</select></label><label class="upf-checkbox"><input type="checkbox" name="available"'+(this.onlyAvailable?' checked':'')+'>'+this.esc(this.t.available)+'</label>'+
        '<div class="upf-actions"><button type="button" class="upf-button upf-button--secondary" data-back>'+this.esc(this.t.back)+'</button><button type="submit" class="upf-button">'+this.esc(this.t.show)+'</button></div></form>'+
        '<p class="upf-hint">'+this.esc(this.hint())+'</p>');
      this.stage.querySelector("[data-back]").addEventListener("click",()=>this.showTypes());
      this.stage.querySelector("form").addEventListener("submit",event=>{
        event.preventDefault();
        const data = new FormData(event.currentTarget);
        this.budget = data.get("budget");
        this.sort = data.get("sort");
        this.onlyAvailable = data.has("available");
        this.loadProducts();
      });
    }
    async loadProducts() {
      this.heading(2,this.t.loading);
      const token = this.sequence;
      this.controller = new AbortController();
      this.actions().append(this.button(this.t.back,()=>this.showBudget(),true));
      try {
        let products = this.cache.get(this.category.url);
        if (!products) {
          products = [];
          let page = 1, pages = 1;
          do {
            const url = new URL(this.category.url,location.origin);
            if (url.origin !== location.origin || !url.pathname.includes("/collections/")) throw new Error("Invalid collection");
            url.searchParams.set("section_id","unitz-finder-data");
            url.searchParams.set("page",page);
            const preview = new URL(location.href).searchParams.get("preview_theme_id");
            if (preview) url.searchParams.set("preview_theme_id",preview);
            const response = await fetch(url,{signal:this.controller.signal,credentials:"same-origin"});
            if (!response.ok) throw new Error("Could not load products");
            const doc = new DOMParser().parseFromString(await response.text(),"text/html");
            const source = doc.querySelector("[data-finder-products]");
            if (!source) throw new Error("Missing product data");
            const data = JSON.parse(source.textContent);
            if (!Array.isArray(data.products) || data.page !== page || data.pages > 100) throw new Error("Invalid product data");
            products.push(...data.products);
            pages = data.pages;
            page++;
          } while(page <= pages);
          products = [...new Map(products.map(p=>[p.id,p])).values()];
          this.cache.set(this.category.url,products);
        }
        if (token !== this.sequence) return;
        const ceiling = this.budget === "" ? Infinity : Math.round(Number(this.budget)*100);
        const candidates = products.map(p => this.onlyAvailable && p.available ? {...p, price:p.availablePrice ?? p.price, priceText:p.availablePriceText ?? p.priceText, url:p.availableUrl ?? p.url} : p);
        this.matches = candidates.filter(p=>(!this.onlyAvailable || p.available) && p.price<=ceiling);
        if (this.sort==="low") this.matches.sort((a,b)=>a.price-b.price);
        if (this.sort==="high") this.matches.sort((a,b)=>b.price-a.price);
        this.limit = 6;
        this.showResults();
      } catch(error) {
        if (error.name==="AbortError" || token!==this.sequence) return;
        this.heading(2,this.t.error);
        const actions = this.actions();
        actions.append(this.button(this.t.edit,()=>this.showBudget(),true));
        actions.append(this.collectionLink());
      }
    }
    collectionLink() {
      const link = document.createElement("a");
      link.href = this.category.url;
      link.className = "upf-button upf-button--secondary";
      link.textContent = this.t.all;
      return link;
    }
    showResults() {
      this.heading(2,this.matches.length ? this.t.results+" ("+this.matches.length+")" : this.t.empty);
      const summary = document.createElement("p");
      summary.className = "upf-summary";
      summary.textContent = this.category.title + (this.budget!=="" ? " · ≤ "+this.budget+" "+this.dataset.currency : "");
      this.stage.append(summary);
      const hint = document.createElement("p");
      hint.className = "upf-hint";
      hint.textContent = this.hint();
      this.stage.append(hint);
      if(this.matches.length){
        const grid = document.createElement("div");
        grid.className = "upf-results";
        this.stage.append(grid);
        this.renderCards();
        const more = this.button(this.t.more,()=>{
          this.limit+=6;
          this.renderCards();
          more.hidden=this.limit>=this.matches.length;
          this.status.textContent=Math.min(this.limit,this.matches.length)+" / "+this.matches.length+" "+this.t.products;
        },true);
        more.hidden=this.limit>=this.matches.length;
        this.actions().append(more);
        const note=document.createElement("p");
        note.className="upf-price-note";
        note.textContent=this.t.price_note;
        this.stage.append(note);
      }
      const actions=this.actions();
      actions.append(this.button(this.t.edit,()=>this.showBudget(),true));
      actions.append(this.collectionLink());
      actions.append(this.button(this.t.restart,()=>{
        this.budget="";this.sort="relevance";this.onlyAvailable=true;this.showAreas();
      },true));
    }
    renderCards() {
      const grid=this.stage.querySelector(".upf-results");
      grid.replaceChildren();
      this.matches.slice(0,this.limit).forEach(p=>{
        const url=new URL(p.url,location.origin);
        if(url.origin!==location.origin) return;
        const card=document.createElement("article");
        card.className="upf-card";
        const link=document.createElement("a");
        link.href=url.pathname+url.search;
        if(p.image){
          const image=document.createElement("img");
          const imageURL=new URL(p.image,location.origin);
          if(imageURL.protocol==="https:")image.src=imageURL.href;
          image.alt="";image.loading="lazy";image.width=480;image.height=436;
          link.append(image);
        }
        const body=document.createElement("div");
        const title=document.createElement("h4");title.textContent=p.title;
        const price=document.createElement("p");price.textContent=(p.varies?this.t.from+" ":"")+p.priceText;
        body.append(title,price);
        if(!p.available){const status=document.createElement("small");status.textContent=this.t.unavailable;body.append(status);}
        const label=document.createElement("span");label.className="upf-product-link";label.textContent=this.t.details+" →";
        body.append(label);link.append(body);card.append(link);
        const actions=document.createElement('div');actions.className='uz-choice-actions';actions.setAttribute('data-uz-choice-actions','');actions.hidden=!window.unitzChoices;
        const handle=url.pathname.split('/').filter(Boolean).pop();
        ['save','compare'].forEach(key=>{const b=document.createElement('button');b.type='button';b.setAttribute('data-uz-'+key,handle);b.setAttribute('aria-pressed','false');b.textContent=(key==='save'?'♡ ':'⇄ ')+this.t[key];actions.append(b)});card.append(actions);grid.append(card);if(window.unitzChoices)window.unitzChoices.sync();
      });
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["unitz-product-information"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('unitz-complements'))customElements.define('unitz-complements',class extends HTMLElement{connectedCallback(){if(this.dataset.ready)return;this.dataset.ready='true';const url=this.dataset.url;if(!url)return;fetch(url).then(r=>{if(!r.ok)throw new Error();return r.text()}).then(html=>{const doc=new DOMParser().parseFromString(html,'text/html');const content=doc.querySelector('[data-complements]');if(content&&content.querySelector('.uic-grid>a')){this.replaceChildren(content);this.hidden=false}}).catch(()=>{this.hidden=true})}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["unitz-schreiner-aplus"] && !Shopify.designMode) return;
  try {
    
(()=>{const run=root=>{const el=root.querySelector('[data-uzs-variants]');if(!el)return;let vs;try{vs=JSON.parse(el.textContent);}catch(e){return;}
const input=document.querySelector('form[action*="/cart/add"] [name="id"]');if(!input)return;
const set=()=>{const v=vs.find(x=>String(x.id)===String(input.value));if(!v||!v.o)return;const len=String(v.o).split(' ')[0];root.querySelectorAll('[data-uzs-len]').forEach(n=>{n.textContent=len;});};
new MutationObserver(set).observe(input,{attributes:true,attributeFilter:['value']});document.addEventListener('change',()=>setTimeout(set,150));set();};
document.querySelectorAll('.uzs').forEach(run);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('.uzs').forEach(run));})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["unitz-service-center"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get("unitz-service"))customElements.define("unitz-service",class extends HTMLElement{
connectedCallback(){
if(this.ready)return;this.ready=true;this.t=JSON.parse(this.querySelector("[data-service-text]").textContent);
const search=this.querySelector("[data-search]"),questions=[...this.querySelectorAll("[data-question]")],filters=[...this.querySelectorAll("[data-category]:not(details)")];let category="all";
const norm=value=>value.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g,"").replace(/ß/g,"ss");
const update=()=>{const terms=norm(search.value).trim().split(/\s+/).filter(Boolean);let count=0;questions.forEach(q=>{const match=(category==="all"||q.dataset.category===category)&&terms.every(t=>norm(q.textContent).includes(t));q.hidden=!match;q.open=match&&terms.length>0;if(match)count++});this.querySelector("[data-search-status]").textContent=count+" "+this.t.found;this.querySelector("[data-no-results]").hidden=count>0};
if(search){search.addEventListener("input",update);filters.forEach(b=>b.addEventListener("click",()=>{category=b.dataset.category;filters.forEach(x=>x.setAttribute("aria-pressed",String(x===b)));update()}));const applyHash=()=>{const active=filters.find(b=>b.dataset.category===location.hash.slice(1));if(active){active.click();this.querySelector(".uzs-faq").scrollIntoView({block:"start"})}};window.addEventListener("hashchange",applyHash);applyHash();update()}
const topic=this.querySelector("[data-topic]");if(topic){const updateTopic=()=>{this.querySelector("[data-topic-hint]").textContent=this.t["hint_"+topic.value]||"";const details=this.querySelector("[data-installation]");details.hidden=!["montage","lieferung"].includes(topic.value);details.querySelectorAll("input").forEach(i=>i.disabled=details.hidden);this.querySelector("[data-phone]").required=topic.value==="rueckruf";const plan=this.querySelector("#ServicePlan");plan.closest("label").hidden=!["beratung","montage"].includes(topic.value);plan.disabled=plan.closest("label").hidden;this.querySelector("#ServicePlanHint").hidden=plan.disabled;const serial=this.querySelector("#ServiceSerial");serial.closest("label").hidden=!["ersatzteil","anleitung","sicherheit","reklamation"].includes(topic.value);serial.disabled=serial.closest("label").hidden;this.querySelector("[data-return-guidance]").hidden=topic.value!=="retoure"};
const params=new URL(location.href).searchParams;for(const [key,id] of [["produkt","ServiceProduct"],["planung","ServicePlan"]]){const value=params.get(key);const input=this.querySelector("#"+id);if(input&&value&&!input.value)input.value=value.slice(0,1000)}const preset=params.get("anliegen");if([...topic.options].some(o=>o.value===preset))topic.value=preset;topic.addEventListener("change",updateTopic);updateTopic()}
}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["unitz-shopping-tools"]) return;
  try {
    
(() => {
 const host=document.querySelector('.uz-shop-tools'); if(!host||window.unitzChoices)return;
 const t=JSON.parse(host.querySelector('[data-uz-labels]').textContent),dialog=host.querySelector('dialog'),content=host.querySelector('[data-uz-content]'),message=host.querySelector('[data-uz-message]');
 const keys={saved:'unitz.saved.v1',compare:'unitz.compare.v1'};let mode='saved',sequence=0,toastTimer,opener;
 const valid=x=>x&&typeof x.handle==='string'&&/^[a-z0-9][a-z0-9-]*$/.test(x.handle);
 const read=key=>{try{const a=JSON.parse(localStorage.getItem(keys[key])||'[]');return Array.isArray(a)?a.filter(valid).slice(0,key==='saved'?30:3):[]}catch{return []}};
 let state={saved:read('saved'),compare:read('compare')};
 const el=(tag,text,cls)=>{const n=document.createElement(tag);if(text!==undefined)n.textContent=text;if(cls)n.className=cls;return n};
 const toast=text=>{const n=host.querySelector('[data-uz-toast]');n.textContent=text;n.hidden=false;clearTimeout(toastTimer);toastTimer=setTimeout(()=>n.hidden=true,4500)};
 const sync=()=>{document.querySelectorAll('[data-uz-choice-actions],[data-uz-open]').forEach(n=>n.hidden=false);document.querySelectorAll('[data-uz-count]').forEach(n=>{const count=state[n.dataset.uzCount].length;n.textContent=count;n.hidden=count===0});for(const key of ['saved','compare'])document.querySelectorAll(key==='saved'?'[data-uz-save]':'[data-uz-compare]').forEach(n=>n.setAttribute('aria-pressed',String(state[key].some(x=>x.handle===(n.dataset.uzSave||n.dataset.uzCompare)))))};
 const save=(key,next)=>{try{localStorage.setItem(keys[key],JSON.stringify(next));state[key]=next;sync();return true}catch{toast(t.storage_error);return false}};
 const toggle=(key,handle,variant)=>{if(!valid({handle}))return;const exists=state[key].some(x=>x.handle===handle);if(!exists&&state[key].length>=(key==='saved'?30:3)){toast(t.limit);return}if(save(key,exists?state[key].filter(x=>x.handle!==handle):[...state[key],{handle,variant:variant||null}]))toast(exists?t.removed:key==='saved'?t.saved_added:t.compare_added)};
 const productURL=x=>{const u=new URL(host.dataset.root+'products/'+x.handle,location.origin);if(x.variant&&/^\d+$/.test(String(x.variant)))u.searchParams.set('variant',x.variant);return u};
 const fetchProduct=async x=>{const u=productURL(x);u.searchParams.set('section_id','unitz-choice-data');const r=await fetch(u,{signal:AbortSignal.timeout(15000)});if(!r.ok)throw Error();const doc=new DOMParser().parseFromString(await r.text(),'text/html');const data=JSON.parse(doc.querySelector('[data-uz-product]')?.textContent||'null');if(!data?.handle)throw Error();return data};
 const facts=p=>{const doc=new DOMParser().parseFromString(p.description||'','text/html'),rows=[...doc.querySelectorAll('li,tr,p')].map(e=>e.textContent.replace(/\s+/g,' ').trim()).filter(s=>s.length<240);const find=regex=>rows.filter(s=>regex.test(s)).slice(0,3).join(' · ')||t.unknown;return {dimensions:find(/^(gesamtbreite|gesamtmaße|maße|abmessungen|breite|höhe|tiefe|länge|durchmesser)\s*[:(]/i),material:find(/^(material(?:\/farbe)?|materialien|oberfläche)\s*:/i),assembly:/^Vormontierte Küchen$/i.test(p.type)?t.prebuilt:/^Zerlegte Küchen$/i.test(p.type)?t.flat:find(/^(montage|lieferzustand)\s*:/i),delivery:p.delivery||find(/^lieferzeit\s*:/i)}};
 const link=(p)=>{const a=el('a',p.title);a.href=productURL(p);return a};
 const picture=p=>{if(!p.image)return el('span');const img=el('img');const u=new URL(p.image,location.origin);if(u.protocol==='https:')img.src=u.href;img.alt='';img.loading='lazy';return img};
 const button=(label,fn)=>{const b=el('button',label);b.type='button';b.onclick=fn;return b};
 const remove=(key,handle)=>{if(save(key,state[key].filter(x=>x.handle!==handle)))render()};
 async function render(){const seq=++sequence;const items=[...state[mode]];host.querySelector('#UzChoiceTitle').textContent=t[mode==='saved'?'saved':'comparison'];message.textContent=items.length?t.loading:t[mode==='saved'?'empty_saved':'empty_compare'];content.replaceChildren();if(!items.length)return;
 const result=await Promise.allSettled(items.map(fetchProduct));if(seq!==sequence||!dialog.open)return;message.textContent='';const good=[];result.forEach((r,i)=>{if(r.status==='fulfilled')good.push(r.value);else{const n=el('div',items[i].handle+' — '+t.error,'uz-choice-item');n.append(button(t.retry,render),button(t.remove,()=>remove(mode,items[i].handle)));content.append(n)}});
 if(mode==='saved'){const list=el('div',undefined,'uz-choice-list');good.forEach(p=>{const card=el('article',undefined,'uz-choice-item');card.append(picture(p),link(p),el('p',p.price),el('p',p.variantTitle==='Default Title'?'':p.variantTitle),button(t.compare,()=>toggle('compare',p.handle,p.variant)),button(t.remove,()=>remove('saved',p.handle)));list.append(card)});content.append(list)}
 else if(good.length){if(new Set(good.map(p=>p.type)).size>1)content.append(el('p',t.mixed));const scroll=el('div',undefined,'uz-choice-scroll'),table=el('table',undefined,'uz-choice-table'),caption=el('caption',t.comparison,'visually-hidden');table.append(caption);const head=el('thead'),hr=el('tr');hr.append(el('th',t.product));good.forEach(p=>{const td=el('td');td.append(picture(p),link(p),button(t.remove,()=>remove('compare',p.handle)));hr.append(td)});head.append(hr);table.append(head);const body=el('tbody');const mapped=good.map(p=>({...p,...facts(p),variant:p.variantTitle==='Default Title'?'—':p.variantTitle,availability:p.available?t.available:t.unavailable}));for(const key of ['price','variant','type','dimensions','material','assembly','delivery','availability']){const row=el('tr'),th=el('th',t[key]);th.scope='row';row.append(th);mapped.forEach(p=>row.append(el('td',p[key]||t.unknown)));body.append(row)}table.append(body);scroll.append(table);content.append(scroll,el('p',t.price_note))}
 }
 const open=key=>{mode=key;opener=document.activeElement;if(!dialog.open)dialog.showModal();render()};
 document.addEventListener('click',e=>{const b=e.target.closest('[data-uz-save],[data-uz-compare],[data-uz-open]');if(!b)return;e.preventDefault();if(b.dataset.uzOpen){open(b.dataset.uzOpen);return}const root=b.closest('[id^="MainProduct-"]');const variant=root?.querySelector('form[action*="/cart/add"] [name="id"]')?.value;toggle(b.dataset.uzSave?'saved':'compare',b.dataset.uzSave||b.dataset.uzCompare,variant)});
 host.querySelector('[data-uz-close]').onclick=()=>dialog.close();dialog.addEventListener('close',()=>{sequence++;opener?.focus()});dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close()}});
 window.addEventListener('storage',e=>{if(Object.values(keys).includes(e.key)){state={saved:read('saved'),compare:read('compare')};sync();if(dialog.open)render()}});
 let scheduled=false;new MutationObserver(records=>{if(records.some(r=>[...r.addedNodes].some(n=>n.nodeType===1&&(n.matches?.('[data-uz-choice-actions]')||n.querySelector?.('[data-uz-choice-actions]'))))&&!scheduled){scheduled=true;requestAnimationFrame(()=>{scheduled=false;sync()})}}).observe(document.body,{childList:true,subtree:true});
 window.unitzChoices={sync,toggle};sync();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["unitz-withdrawal"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-uz-withdrawal]').forEach(root=>{const form=root.querySelector('form'),fields=root.querySelector('[data-withdrawal-fields]'),confirm=root.querySelector('[data-withdrawal-confirm]');if(!fields)return;const entries=()=>[['Name',root.querySelector('[data-withdrawal-name]').value],['E-Mail',root.querySelector('[data-withdrawal-email]').value],['Vertrag / Bestellung',root.querySelector('[data-withdrawal-contract]').value],['Umfang',root.querySelector('[data-withdrawal-scope]').value]];root.querySelector('[data-withdrawal-review]').addEventListener('click',()=>{if(!form.reportValidity())return;const summary=root.querySelector('[data-withdrawal-summary]');summary.replaceChildren();entries().forEach(([key,value])=>{const dt=document.createElement('dt'),dd=document.createElement('dd');dt.textContent=key;dd.textContent=value;summary.append(dt,dd);});fields.hidden=true;confirm.hidden=false;confirm.querySelector('button[type="submit"]').focus();});root.querySelector('[data-withdrawal-back]').addEventListener('click',()=>{confirm.hidden=true;fields.hidden=false;fields.querySelector('input').focus();});form.addEventListener('submit',()=>{root.querySelector('[data-withdrawal-body]').value='Hiermit widerrufe ich den angegebenen Vertrag bzw. den angegebenen Teil.\n'+entries().map(([k,v])=>k+': '+v).join('\n')+'\nÜbermittlung ausgelöst: '+new Date().toISOString();});});

  } catch(e) { console.error(e); }
})();
})();
